﻿import { Title } from '@solidjs/meta';

export type TitleProps = {
  title?: string;
  hidePrefix?: boolean;
};
export const SiteTitle = (props: TitleProps) => {
  return (
    <Title>
      {props.hidePrefix !== undefined && props.hidePrefix ? '' : 'AtgFr8 - '}
      {props.title}
    </Title>
  );
};
